import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActivityItem,
  MemberTrend,
  NewsItem,
  PolicyArticles,
  PolicyCategory,
} from "../model/OtherModel";
import {
  ActivityServices,
  MemberService,
  NewsServices,
  PolicyServices,
} from "../service/Service";

export interface OtherState {
  activityList: ActivityItem[];
  activityPic: string;
  activityTitle: string;
  activityTotal: number;
  activityCurrent: number;

  memberPic: string;
  memberTitle: string;
  memberTrend: MemberTrend[];

  policyArticles: PolicyArticles[];
  policyCategory: PolicyCategory[];
  policyPic: string;
  policyTitle: string;
  policyTotal: number;
  policyCurrent: number;
  policySort: number;
  policyTime: number;

  newsList: NewsItem[];
  newsTitle: string;
  newsPic: string;
  newCategory: PolicyCategory[];
  newTime: number;
  newSort: number;
  newInfo:any
  newmediaPdf:any
}

const initialState: OtherState = {
  activityList: [],
  activityPic: "",
  activityTotal: 0,
  activityTitle: "",
  activityCurrent: 1,

  memberPic: "",
  memberTitle: "",
  memberTrend: [],

  policyArticles: [],
  policyCategory: [],
  policyPic: "",
  policyTitle: "",
  policyTotal: 0,
  policyCurrent: 0,
  policyTime: 0,
  policySort: 0,

  newsList: [],
  newsPic: "",
  newsTitle: "",
  newCategory: [],
  newTime: 0,
  newSort: 0,
  newInfo:{},
  newmediaPdf:''
};

export const activityAsync = createAsyncThunk(
  "activity/getActivityData",
  async ({
    page,
    category,
    time,
  }: {
    page: number;
    category: number;
    time: number;
  }) => {
    const response = await ActivityServices.activity({
      page,
      category,
      time,
    });
    return response.data;
  }
);

export const policyAsync = createAsyncThunk(
  "policy/getPolicyData",
  async ({
    page,
    category,
    time,
  }: {
    page: number;
    category: number;
    time: number;
  }) => {
    const response = await PolicyServices.policy({
      page,
      category,
      time,
    });
    return response.data;
  }
);

export const newsAsync = createAsyncThunk(
  "news/getNewsData",
  async ({
    page,
    category,
    time,
    year,
  }: {
    page: number;
    category: number;
    time: number;
    year?:any
  }) => {
    const response = await NewsServices.news({
      page,
      category,
      time,
      year 
    });
    return response.data;
  }
);

export const mediaAsync = createAsyncThunk(
  "news/getMediaData",
  async ({
    page,
    category,
    time,
    year,
  }: {
    page: number;
    category: number;
    time: number;
    year?:string
  }) => {
    const response = await NewsServices.media({
      page,
      category,
      time,
      year
    });
    return response.data;
  }
);

export const memberAsync = createAsyncThunk(
  "member/getMemberData",
  async (page: number) => {
    const response = await MemberService.member(page);
    
    return response.data;
  }
);

export const OtherStore = createSlice({
  name: "other",
  initialState,
  reducers: {
    setActivityCurrent: (state, action: PayloadAction<number>) => {
      state.activityCurrent = action.payload;
    },
    setPolicyCurrent: (state, action: PayloadAction<number>) => {
      state.policyCurrent = action.payload;
    },
    setPolicyTime: (state, action: PayloadAction<number>) => {
      state.policyTime = action.payload;
    },
    setPolicySort: (state, action: PayloadAction<number>) => {
      state.policySort = action.payload;
    },

    resetNews: (state) => {
      state.newsTitle = "";
      state.newsPic = "";
      state.newsList = [];
      state.newCategory = [];
      state.newSort = 0;
      state.newTime = 0;
      state.newInfo= {};
      state.newmediaPdf=''
    },
    setNewsTime: (state, action: PayloadAction<number>) => {
      state.newTime = action.payload;
    },
    setNewsSort: (state, action: PayloadAction<number>) => {
      state.newSort = action.payload;
    },
  
  },
  extraReducers: (builder) => {
    builder.addCase(activityAsync.fulfilled, (state, actions) => {
      state.activityList = (actions.payload && actions.payload.activity) || [];
      state.activityPic = (actions.payload && actions.payload.pic) || "";
      state.activityTitle = (actions.payload && actions.payload.title) || "";
      state.activityTotal = (actions.payload && actions.payload.total) || 0;
    });
    builder.addCase(memberAsync.fulfilled, (state, actions) => {
      state.memberTrend = (actions.payload && actions.payload.trend) || [];
      state.memberPic = (actions.payload && actions.payload.pic) || "";
      state.memberTitle = (actions.payload && actions.payload.title) || "";
    });
    builder.addCase(policyAsync.fulfilled, (state, actions) => {
      state.policyArticles =
        (actions.payload && actions.payload.articles) || [];
      state.policyCategory =
        (actions.payload && actions.payload.category) || [];
      state.policyPic = (actions.payload && actions.payload.pic) || "";
      state.policyTitle = (actions.payload && actions.payload.title) || "";
      state.policyTotal = (actions.payload && actions.payload.total) || 0;
    });

    builder.addCase(newsAsync.fulfilled, (state, actions) => {
      state.newCategory = (actions.payload && actions.payload.category) || [];
      state.newsList = (actions.payload && actions.payload.news) || [];
      state.newsPic = (actions.payload && actions.payload.pic) || "";
      state.newsTitle = (actions.payload && actions.payload.title) || "";
      state.newInfo =(actions.payload && actions.payload.info) || {};
    });
    builder.addCase(mediaAsync.fulfilled, (state, actions) => {
      state.newCategory = (actions.payload && actions.payload.category) || [];
      state.newsList = (actions.payload && actions.payload.news) || [];
      state.newsPic = (actions.payload && actions.payload.pic) || "";
      state.newsTitle = (actions.payload && actions.payload.title) || "";
      state.newmediaPdf=(actions.payload && actions.payload.pdf)
      state.newInfo =(actions.payload && actions.payload.info) || {};
    });
  },
});

export const {
  setActivityCurrent,
  setPolicyCurrent,
  setPolicyTime,
  setPolicySort,
  resetNews,
  setNewsTime,
  setNewsSort
} = OtherStore.actions;

export default OtherStore.reducer;
